import { render, staticRenderFns } from "./ModalES.vue?vue&type=template&id=0494796a&scoped=true&"
import script from "./ModalES.vue?vue&type=script&lang=js&"
export * from "./ModalES.vue?vue&type=script&lang=js&"
import style0 from "./ModalES.vue?vue&type=style&index=0&id=0494796a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0494796a",
  null
  
)

export default component.exports